import { Kerngruppe } from '../kerngruppe/kerngruppe.model';
export class Kernbenutzer {
	id: string;
	kernGruppen: Kerngruppe[];
	login: string;
	passwort: string;
	passwortalt: string;
	passwortwiederholung: string;
	email: string;
	name: string;
	aktiv: boolean;
	hatFuhrlohnabrechnung: boolean;
	eingeloggtseit: number; // Wird nicht vom Backend gelifert sondern nur am Client gesetzt wenn sich der Benutzer einloggt
}
